jest.useFakeTimers();

import React from "react";
import { render, RenderOptions } from "@testing-library/react-native";
import { FlipUiProvider } from "..";

const inset = {
  frame: { x: 0, y: 0, width: 0, height: 0 },
  insets: { top: 0, left: 0, right: 0, bottom: 0 },
};

const AllTheProviders = ({ children }: any) => {
  return (
    <FlipUiProvider initialWindowMetrics={inset}>{children}</FlipUiProvider>
  );
};

const customRender = (ui: any, options?: RenderOptions) =>
  render(ui, { wrapper: AllTheProviders, ...options });

export * from "@testing-library/react-native";

export { customRender as render };
